// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";   


// export default function CEFPPC() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Creation/Expansion of Food Processing & Preservation Capacities (CEFPPC) (Unit Scheme) from MOFPI</h1>
                                 
//                                   <h2>What is CEFPPC Scheme?</h2>
//                                   <p>The main objective of the Scheme is creation of processing and preservation capacities and modernisation/ expansion of existing food processing units with a view to increasing the level of processing, value addition leading to reduction of wastage.</p>
                                  
//                                   <h2>About the CEFPPC Scheme</h2>
//                                   <p>Covers a wide range of post-harvest processes that create added value with specialized facilities for the preservation of perishable products and / or improve shelf life, as well as improve product quality.</p>

//                                 </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <p>The establishment of new units and the modernization / expansion of existing units are covered under the scheme. Joint Ventures / Farmer Procedures Organization (FPO's) / NGOs / Cooperatives / SHGs / Pvt.Ltd Sole proprietorships / Companies involved in the establishment / improvement / modernization of food processing units Proposals for obtaining support under the Scheme will be made about the interests of From time to time to view notice and to sumbit the online proposals, contact us</p>

//                                   <h2>Project components</h2>
//                                   <p>Eligible project components include the costs for Plant, machines and systems as well as for technical civil work. The costs for essential "utilities" for plant that is also considered eligible projects. Water pipe, attic set, boiler, solid waste treatment plant, ETP, etc. The costs, which are subject to the above cost restrictions, amount to a maximum of 25% of the total project costs.</p>

//                                   <h2>Pattern of Assistance</h2>
//                                   <p>The policy provides for grants in aid of 35% of qualified project costs in main areas and 50% of qualified project costs in the North East States, particularly Sikkim and complicated regions, such as the Himalayan states, the state declared ITDP areas subject to a maximum of Rs. 5 crores per project.</p>

//                                   <h2>Release of Grant</h2>
//                                   <p>The grant is paid out in two installments of 50% of the grant each as follows:</p>
//                                   <p>The first installment of the grant is released after the company has drawn 50% of the fixed-term loan, as well as 50% of the promoter's contribution and then the creation of the required documents.</p>
//                                   <p>The second installment is released at the start of the commercial presentation and documentation to use the 1st installment of the grant and 100% of the term loan and 100% of the promoter's contribution.</p>
                                      

//                                   <h2>Important to remember</h2>
//                                   <p>If the project is not completed in time within the approved project period. If any applicant does not submit complete documents for release of 2nd & final installment of grants-in-aid as per scheme guidelines within two months from the date of start of commercial operation</p>

//                                   <h2>How we assist you?</h2>
//                                   <p>Enrich Services Consultants is a professional consulting firm that provides services with respect to Creation / Expansion of Food Processing & Preservation Capacities. We are ISO 9001:2015 certified organisation with stringent processes to deliver best-in-the-industry services.</p>

//                                   <h2>Our Unique Services</h2>
//                                   <ul>
//                                       <li>Preparation of Detailed Project Reports (DPR)</li>
//                                       <li>Layout Drawings</li>
//                                       <li>Facilitating various permissions required from various Govt. Departments</li>
//                                       <li>Error free application processing for various subsidies and incentives</li>
//                                       <li>Facilitating the arrangement of subsidies and incentives from Govt. Departments</li>
//                                   </ul>
                                  
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping,
  FaExclamationTriangle
} from "react-icons/fa";

export default function CEFPPC() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4">
            <Col lg={12}>
              <h1>
                CEFPPC Scheme – Food Processing Capacity Expansion
              </h1>

              <p>
                The CEFPPC Scheme is an initiative by the Ministry of Food Processing Industries (MoFPI)
                aimed at strengthening India's food processing sector through modernization,
                expansion, and value addition.
              </p>

              <p>
                It helps businesses reduce losses, improve quality, and scale operations efficiently.
              </p>
            </Col>
          </Row>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Scheme Objective
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Enhance food processing capacity</li>
            <li><FaCheckCircle /> Increase value addition</li>
            <li><FaCheckCircle /> Reduce post-harvest losses</li>
            <li><FaCheckCircle /> Modernize existing units</li>
          </ul>

          {/* SCOPE */}
          <h2 className="section-title">
            <FaList className="icon" /> Scope of the Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> New food processing units</li>
            <li><FaCheckCircle /> Expansion of existing units</li>
            <li><FaCheckCircle /> Technology modernization</li>
            <li><FaCheckCircle /> Improved shelf life & product quality</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Eligible Applicants
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Entrepreneurs & companies</li>
            <li><FaCheckCircle /> Farmer Producer Organizations (FPOs)</li>
            <li><FaCheckCircle /> Cooperatives & NGOs</li>
            <li><FaCheckCircle /> SHGs & joint ventures</li>
          </ul>

          {/* COMPONENTS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Project Components
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Plant & machinery</li>
            <li><FaCheckCircle /> Technical civil work</li>
            <li><FaCheckCircle /> Water systems & utilities</li>
            <li><FaCheckCircle /> Boilers & ETP systems</li>
            <li><FaCheckCircle /> Waste management systems</li>
          </ul>

          {/* FINANCIAL */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Financial Assistance
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 35% subsidy (general areas)</li>
            <li><FaCheckCircle /> 50% subsidy (NE & hilly regions)</li>
            <li><FaCheckCircle /> Maximum ₹5 Crores per project</li>
          </ul>

          {/* GRANT */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Grant Disbursement
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 1st Installment – 50%</li>
            <li><FaCheckCircle /> 2nd Installment – 50%</li>
            <li><FaCheckCircle /> Based on loan utilization & operations</li>
          </ul>

          {/* COMPLIANCE */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Key Compliance Points
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Complete project within timeline</li>
            <li><FaCheckCircle /> Submit required documents</li>
            <li><FaCheckCircle /> Avoid delays to prevent rejection</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide end-to-end support including DPR preparation,
            documentation, application filing, and coordination with authorities to ensure
            smooth approvals and subsidy disbursement.
          </p>

          {/* WHY CHOOSE */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Why Choose Us
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Complete project lifecycle support</li>
            <li><FaCheckCircle /> Expert DPR & technical planning</li>
            <li><FaCheckCircle /> Faster approvals</li>
            <li><FaCheckCircle /> Error-free documentation</li>
            <li><FaCheckCircle /> Customized business solutions</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}